import { useState, useEffect } from 'react';

const breakpoints = {
  xSmall: '(min-width: 0px) and (max-width: 412px)',
  small: '(min-width: 413px) and (max-width: 767px)',
  medium: '(min-width: 768px) and (max-width: 1023px)',
  large: '(min-width: 1024px) and (max-width: 1279px)',
  xLarge: '(min-width: 1280px)',
};

export default function useBreakpoint(breakpoint) {
  const mediaQuery = breakpoints[breakpoint];
  const [isMatch, setIsMatch] = useState(false);

  useEffect(() => {
    let media;
    if (global.BROWSER) {
      media = window?.matchMedia(mediaQuery);
    }
    if (media?.matches !== isMatch) {
      setIsMatch(media?.matches);
    }
    const listener = () => {
      setIsMatch(media?.matches);
    };
    // TODO: Change to media?.addEventListener('change', listener); when https://github.com/bigslycat/mq-polyfill/issues/7 is resolved
    media?.addListener(listener);
    return () => {
      // TODO: Change to media?.removeEventListener('change', listener); when https://github.com/bigslycat/mq-polyfill/issues/7 is resolved
      media?.removeListener(listener);
    };
  }, [isMatch, mediaQuery]);

  return isMatch;
}
